export default __webpack_public_path__ + "static/media/NotoSerifMalayalam.78793c3a.ttf";